import { LegalLayout, LegalSection } from "../components/Legal";

const SECTIONS = [
  {
    title: "Licensed & Insured",
    content: (
      <p>
        Cindyrella Cleaning LLC is a licensed cleaning company registered in the State of
        Florida and carries full business insurance, including general liability coverage.
        Certificates of insurance (COI) are available to commercial and government clients upon
        request. Proof of licensing and insurance can be provided as part of any bid or contract
        package.
      </p>
    ),
  },
  {
    title: "Workplace Safety",
    content: (
      <>
        <p>
          The safety of our team, our clients, and every facility we serve comes first. Our safety
          practices include:
        </p>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            Training for all team members in safe cleaning procedures, equipment handling, and
            chemical use, consistent with OSHA guidance.
          </li>
          <li>Use of appropriate personal protective equipment (PPE) for each task.</li>
          <li>
            Proper labeling, storage, and handling of cleaning products, with Safety Data Sheets
            (SDS) available for the products we use.
          </li>
          <li>
            Wet-floor signage and site-specific precautions to protect building occupants during
            and after cleaning.
          </li>
          <li>
            Compliance with site-specific safety and security protocols at commercial and
            government facilities.
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "Trusted Team",
    content: (
      <p>
        Our team members are trained, supervised, and held to high standards of professionalism
        and confidentiality. We understand the level of trust our clients place in us when we
        work in their homes, businesses, and public facilities, and we protect that trust on
        every visit.
      </p>
    ),
  },
  {
    title: "Health Standards",
    content: (
      <p>
        For restaurants and public facilities, our cleaning procedures are designed to
        support compliance with applicable health codes and facility standards. We adapt
        products and procedures to each environment, including green cleaning options upon
        request.
      </p>
    ),
  },
  {
    title: "Accountability",
    content: (
      <p>
        Any incident, damage, or safety concern is reported and addressed promptly. Clients can
        reach our management team directly at any time at (239) 244-1934 or
        info@cindyrellaclean.com.
      </p>
    ),
  },
];

export default function SafetyPage() {
  return (
    <LegalLayout badge="Legal" title="Safety & Insurance Commitment" testid="safety-page">
      {SECTIONS.map(({ title, content }) => (
        <LegalSection key={title} title={title}>
          {content}
        </LegalSection>
      ))}
    </LegalLayout>
  );
}
